import { Component, OnInit, OnDestroy, ElementRef, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { trigger, transition, style, animate } from '@angular/animations';
import { FormDataService } from 'src/app/shared/form-data.service';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { NgbDateStruct, NgbDatepickerConfig, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from 'src/app/shared/config.service';

import { PagerService } from 'src/app/shared/pager.service';
import { ToastrService } from 'ngx-toastr';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/main/modal/modal.component';
import { IImageZone } from '../../core/interfaces/image-zone.interface';
import { ISelectedChip } from '../../shared/selected-chips/selected-chips.component';

//import { MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '-';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day.toString().padStart(2, '0') + this.DELIMITER + date.month.toString().padStart(2, '0') + this.DELIMITER + date.year : null;
  }
}

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(12px)' }),
        animate('300ms ease', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease', style({ opacity: 0, transform: 'translateY(12px)' }))
      ])
    ])
  ]
})
export class QuestionsComponent implements OnInit, OnDestroy {

  questions = [];
  answers = [];
  questionsForm: FormGroup;
  // pager object
  pager: any = {};

  // paged items
  pagedItems: any[];
  contentDetail: any;
  errorMsg: string;
  enableSubmitBtn: boolean;
  isEasyClaimTlAcceptType: boolean;
  damageConditions: any[];
  directionOfImpacts: any[];
  maxDate = new Date();
  selectedValue = "Select";
  directionOfImpactValue = "";
  investigationType = "";
  stpDelay: Number;
  showcbTermsConditions: boolean;
  isAnswersValid: boolean;
  damageDetails: any[];
  damageParts: string[] = [];

  displayStyleQuestion: string = "none";
  selectedHeader: string = '';
  selectedDetail: string = '';
  airbagsForm = new FormGroup({
    main: new FormControl([]),
    additional: new FormControl([])
  });

  public selectedAirbags: string[] = [];
  public selectedAirbagChips: ISelectedChip[] = [];
  private unsubscribe$ = new Subject<void>();

  private roofTriggerZones: string[] = ['Left Front Door', 'Right Front Door', 'Left Roof', 'Right Roof'];

  private airbagEnumMap: { [zoneName: string]: string } = {
    'Steering Wheel': 'SteeringWheel',
    'Instrument Panel': 'InstrumentPanel',
    'Left Front Door': 'FrontLeftDoor',
    'Right Front Door': 'FrontRightDoor',
    'Left Front Seat': 'LeftFrontSeat',
    'Right Front Seat': 'RightFrontSeat',
    'Left Rear Door': 'RearLeftDoor',
    'Right Rear Door': 'RearRightDoor',
    'Rear Left': 'RearLeft',
    Rear: 'Rear',
    'Rear Right': 'RearRight',
    'Passenger Dash Lower Panel': 'FrontPassengerDashPanelLower',
    'Left Lower Front Seat': 'LeftFrontSeatLower',
    'Driver Instrument Lower Panel': 'InstrumentPanelLower',
    'Right Lower Front Seat': 'RightFrontSeatLower',
    'Left Roof': 'LeftRoof',
    'Right Roof': 'RightRoof',
    Roof: 'Roof'
  };

  public airbags: IImageZone[] = [
    {
      zoneNames: ['Instrument Panel'],
      path: 'M354 126.5L354.5 124.5L355 123.5V121.5V119.5L355.5 117.5L356.5 115.5L357.5 114.5L358.5 113.5L359.5 112L360.5 110.5L361.5 109.5L363 108.5L365 108L367 107L369 106L371.5 105.5L375.5 104L377 103L379.5 102H383L385 101H389L391 100H397L399 99H405L407 98H412L415 97H422L424 96H438L440.5 95H456L458 94.5H466L471 94H474.178H507.5H519.5L525 94.5L528 95H543L545.5 96H548L550 97H552L554 98H556L558 99H560L561.5 99.5L563.5 100L565.5 101L567 102L569 103L571.5 104L573 105L579 111L580 112L581 114L582 116V121V139.5L581.5 142V167.5L581 170V197V222.5L580.5 233L580 235V254L579 256V265.5L578 267.5V277.5L577.5 280L577 282V285.5L576 287.5V291.5L575 293V296.5L574 298.5V302L573 303.5V306L572 308V309.5L571 311V312.5L570.5 314L569.5 316L568.5 318L567.5 320.5L566 322L565.5 323.5L564.5 325.5L564 326.5L563 328V329L562 330L561.5 331.5L560.5 332.5L559.5 334L558.5 335.5L557 337.5L554 340H552.5L551.5 340.5L549.5 341.5L547.5 342.5H545.5L543.5 341.5H519L515 341H472.5L468 341.5L460 342H451H442L439.5 342.5L437 343H420L418 344H416L414 344.5H406L404 344H402L400 343L398 342L396 341L394 340L392.5 339.5L391.5 339L390.5 338.5L389 337L388.5 335.5L387.5 334L386.5 332L385.5 330.5L385 329.5L384 327.5V326L383 324L381 321L380 319.5V318L379 316.5V315L378 313V311L377 309V304.5L376 302.5V299L375 297V293L374 291V288L373 286V282.5L372 280V274.5L371 272.5V267L370 265V260L369 258V252L368 250V244L367 241.112V234L366 231.5V224.5L365 222V218L364 216V202L363 200V194.5L362 193V185L361 182.5V175.5V172L360 170V167.5L359 165.5V160H358V156.5L357 154V149L356 146.5V141L355 139V137L354 134.5V128.5V126.5Z',
    },
    {
      zoneNames: ['Steering Wheel'],
      path: 'M796.5 299.5L794.5 297.5L793 297L791 295L790 293.5V292.5L789.5 291.5L787.5 289.5L787 288.5L786.5 287.5L786 286.5L785.5 285.5L782.5 282.5L782 281.5L781.5 280.5L781 280L780.5 278.5L780 277.5L779.5 276.5L778.5 275.5L777.5 273.5L777 273V270.5L776.5 269.5L776 268.5L775.5 267.5L774.5 265.5L773.5 263.5L773 262.5L772 261V256L771 254V250.5L770 249V247L769.5 245V239.5V237V235.5L770 234.5V231.5L769.5 230.5L770 229V223L771 221V218L771.5 215.5L772.5 212.5L773 211V206L773.5 204.5L774 203L774.5 201.5L776 200L776.5 199V198L777 197V196L777.5 194.5L778 193.5L778.5 192.5L779.5 190.5L780.5 188.5L781 187L782 185.5V184.5L783 183L783.5 181.5L784.5 180.5L785.5 179.5L786 178L786.5 176.5L787.5 175.5L788.5 173.5L789.5 172.5L790.5 171.5L792.5 169.5L793.5 167.5L794.5 166L795 165L796 164L798 162L800 160.5L802 159L807 154L812.5 148.5L813.5 147.5L815 147L817 146H819L821 145L822 144L823.5 142.5L826.5 139.5L828 138L830 137L832 136H836L838 135L840 134H842L843.5 133.5L845 132L847.5 130.5L849 130H852L854 129H855.5L856.5 128.5L857.5 128H862L864 128.5H867L869 128L871 127H880L882 128H885L886.5 127.5H889.5L891.5 128H893.937L896 129H902L903 129.5L904.5 130L906.5 130.5L908.5 131.5L910.5 132.5L913 133.5L916.5 134.5L918.5 135.5L920 136.5H922.5L924 137L925.5 137.5L927 138L928.5 139L929.5 139.5L931.5 141.5L932.5 142L934 143L935.5 144.5L937 145.5L938 146H939L940.5 147L941.5 147.5L942.5 148.5L943.5 149L944.5 149.5L947.5 152.5L952 157L952.5 158H953.5L955 159L956 160L956.5 161L957.5 161.5L960 164V165L966 171V172L967 173V174L968 175L968.5 176.5L969.5 177.5L970 178L971 179L972 180.5V182L973 183V185L974 186V187L975 188L976 189V190L976.5 191V194.5L977 196L977.5 196.5L978 197.5L979 199V200L980 201V202L981 203V205L981.5 206.5V209V210L983 212V213L984 215V219.5L983.5 220.5L983 221V222L984 223V224L985 226V232.5L984 234V235.5L983.5 236.5V237.5L984 238V239L984.5 240.5V243.5L984 244.5V245.5L983.5 247.5L983 248V252.5L982 253.5V255.5V256.5L981 258V259.141L980 261V262.5L979 264L978 265.5L977 266.5L976.5 267.5L975.5 269.5L975 270.5V272L974 273.5V274.5L973 275.5L972.5 276.5L972 277.5L971.5 278.5L970.5 279.5L969.5 281.5L968.5 283L967 284.5L966.5 285.5L964.5 287.5L964 288.5L963 290L961.5 291.5L960 293L959.5 294.5L959 295.5L957 297L955.5 298.5L954.5 299L954 299.5L952 300L951 301.5L948.5 303.5L948 304.5L947.5 305.5L946.5 306L945.5 306.5L944.5 307L944 307.5L942.5 308.5L941.5 309L941 309.5L939.5 310.5L938 311H936L935.5 311.5L931.5 315.5H930.5L929.5 316.5H928.5L927 317L925 318L922.5 320.5L921 321L919.5 322H918L916.5 323.5L914 324.5L911 325.5L907.5 326.5L905 327L902 328L899 328.5L896 329L894 329.5H888.5L883 330L881 330.5H864L862 329.5H850.5L849 329H845.5L844 328H842.5L840.5 326.5H838L836 326L833 324.5L829.5 323L826.5 321.5L824.5 320.5L821.5 318.5L820.5 318L819.5 317.5L814 312L812 311L810 310H809L807.5 309L806 307L804 306H803L801.5 305L801 304L800 302.5L798.5 300.5L796.5 299.5Z',
    },
    {
      zoneNames: ['Left Front Door'],
      path: 'M259 339.5V346L258 348V356L257.5 358.5L257 361V367L256 370V377L255 379V388L254.5 390L254 392V397.5L253 400V404L252 406V413.5L251 415.5V421.5L250.5 424L250 426.5V430V434L249 436V439V443L248 445V449V452.5L247 454.5V459V462.5L246 464.5V469L245 471V477L244.5 479L244 481V491.5L243 493.5V501L242 503V513L241 515V524L241.5 524.5H242.5L244 524H246L248 523H250L251 522.5L252 523L254 524L256 525H262L265 527L266.5 528H269L273 532L273.5 533.5V535L274.5 536V538L276.5 538.5L278 537L278.5 535.5L280.5 533.5V530.5L280 529V527.5L281 526.5L282 525V523L283 521V517L284 515V510L285 508V502L286 500V495L287 493V481L290.5 477.5L291.5 475.5L292.5 474.5L294 472L294.5 470.5L295.5 468.5L296.5 467L297.5 465.5L298 464L299 463L300 461.5L301 460.5L301.5 459.5L303 458L304 456L305.5 453.5L306 452L307 451L308 449L309 447.5L310 445.5L312 443L313 441L314 439L315 437L316.5 435L317.5 433L319 430L321 426.5L322.5 423.5L324 420.5L325.5 417.5L327.5 413.5L330 408L332 402.5L333.5 397.5L335.5 393L336.5 389L337.5 385.5L338 381.5V377.5V374L339 371V368L340 366V358L341 355.5V345V333L340 330.5V324L339 321V318L338 316V313L337 311V309.5L336.5 308.5V307.5L338 305.5L339 304L340 302L341 300V298.5L342 296.5V295L343 293V292L345 288V286L346 284L347 281.5V279L348 277V275L349 273V272L350 270V267.5L350.5 266L351 264V260L352 258V256L353 254V248L353.5 245.5V239L353 237V228.5L352.5 226.5V220L352 218V215L351 213V211L350 209V207L349 205.5L348.5 203.5L347.5 202L346.5 200L345.5 198.5L344.5 197L343 196L341 195L337.5 191.5L337 191H334V184L335 181.5V170L334 167V162L333 160V157L332 155V151.5L331 149V147L330 144V142L329.5 139.5L329 138.5L328.5 136.5L328 135.5V133L327 131L326.5 129.5V128.5L329 126L330 125L330.5 123.5L332 122L332.5 120.5L333 119.5L333.5 118.5L334.5 116.5L335 115V113.5L335.5 112V108L335 106L334 104.5L333.5 103.5L332.5 102L332 100.5L331 99L330.5 97.5L329.5 96H327.5L326 96.5H324H322.5L321.5 96H320.5H319L315 97L313 98L307.5 103.5H303.5L298.5 107.5L297 109L296 111L294 113L292 117V118L291 119V120L290 122L289 124V125L288 126.5L287.5 128.5V131L287 133L286 135V137L285 139V141L284 143V146L283 148V153L282 155V159L281 161V165L280 167V171L279 173V178L278 180V184.5L277 187V193L276 195V200L275 202V208L274 210V216L273 218V223L272 225V232L271 234V241L270 243V250L269 252V258L268 260V267L267 269V274L266 276V282L265 284V289L264 291V297L263.5 300.5L263 303.5V309L262 311V317L261 319V327.5L260 330V337L259 339',
    },
    {
      zoneNames: ['Left Front Seat'],
      path: 'M311 452.5V449.5L311.5 447V444L312 443L315 437L316.5 435L318 432L319 430L320.5 427.5L321.5 425.5L324 420.5L327 414.5L330 408L332 402.5L333.5 397.5L335.5 393L337.5 385.5L338 381.5V374L343 369H345L351 363L353 362L355 361H357L359 360H362L363 359.5H364.5L366 361H367L371 365H372.5L373.5 366H375L377 367L379 369L379.5 370.5L382.5 373.5L383 374.5L383.5 375.5L384.5 376.5L385 378L385.5 378.5L386 380L386.5 381L387 382L388.5 383.5L389 385L391 387V389L392 390.5V392L392.5 393.5V395.5L394.5 397.5L395.5 399.5L396 401L398 405V407L399 409V410.5L400 414V422L400.5 424V429.5L400 431V435L399 437.5V440L398.5 442L398 444V446L397 448V450L396 452V454L395.5 455.5L394.5 457L393.5 458.5H374L371 459H363.5L361 460L359.5 460.5L358 461L355 464L353 466L351.5 468L351 469L350.5 470L349.5 472.5L349 474L348.5 475.5L348 477L347.5 478L347 480.5L346.5 483.5L346 485.5L345.5 488.5L345 491L344.5 493.5V496V499L344 501V505V514.5H326L325 513.5V512L324 510L323 508.5V507L322 505.5V504L321 502V500.5L320.5 498.5L320 496L319.5 494L319 491.5L318.5 489L317.5 486.5V484.5L316.5 482.5L316 478.5L315.5 476.5V474.5L314.5 472.5V470.5L313.5 468.5L312.5 464V462L311.5 458V455L311 452.5Z',
    },
    {
      zoneNames: ['Right Front Seat'],
      path: 'M1024.5 515.5H1007.5L1006 515V513V513.185V492L1005 488V486L1004 483V480L1003 478V476L1002 474V473L999.5 468L998.99 465.586L999 465.5L995 461.5L993.5 460.5L992 460L990 459L988 458.5H984L973.5 457.5H959L958 457L957 455V453L956 451V448L955 446V444.5V439.5L954.5 437.5V435L954 431.957V422L954.5 419V415L955 413V409.5V408.5L956 407V406L956.5 405V404L957 403.5V402.5L958 401V400L959 399L960 397V394.5L960.5 393.5L961 392.5L961.5 391.5L962 391V390L963 389V387.5L963.5 386.5L964 385.5L964.5 384.5L965 383.5L965.5 382.5L966 381L968 379V378L969 377V376L970 375L971 374V373L972 372V371L973 370V369L976 367L978 366L980 365L982 364L983 363L983.5 362.5L984 361.5L985 360.5L986.5 359L987.5 358.5H989.5L990.5 359L991.5 358.5H994.5L995.5 359H998L1000 360L1001.5 360.5L1007 366L1009 367L1010.5 367.5L1011.5 368.5L1014.5 371L1015.5 372.5L1016.5 375.5L1018.5 382V384.5L1019 387.5L1020 390.5L1023 402.5L1024.5 406.5L1026 410L1027.5 414L1030.5 419.5L1034.5 427.5L1038 432.5L1041.5 438.5L1042.5 440.5L1043.5 441.5V442.5V444.5V450L1043 451V453L1042 456L1041 459V462L1040 465L1039.5 467V471L1039 473V475L1038 478L1037 481V483L1036 485.5L1035 488V489.5L1034 492L1033.5 495L1032 499.5L1031 502L1030 505L1025.5 514',
    },
    {
      zoneNames: ['Right Front Door'],
      path: 'M1037.5 93L1035 96H1032.5H1031L1029.5 95.5L1027.5 95H1026.5H1025L1024 96L1023 98L1022 100L1021 102V106L1022 110V113L1024 118L1027 121L1028 122.5L1029 123.5L1030 125L1031 126V127.5L1030 128.5V130L1029 132V134L1028 136V137L1027 139V140L1026 142V143L1025 145V146L1024 148V150L1023 152V154L1022 156V158L1021 160V162L1020 164V166L1019 168V170.5V172L1018 174V178.5L1017.5 180V183L1017 186V192L1017.5 195V197.5L1018 199V200L1017 201L1015 202L1011 205L1010 206L1008.5 207.5L1008 209L1007 210.5L1006 212.5V214L1005 216V217L1004 219L1003 221V224L1002 226V227.5V231.5L1001.5 233V238L1002 241L1002.5 244V246.5L1003.5 248.5V252.5L1004 255V259.5L1005 262.5V270L1006 273V278L1007 281V284L1008 286V290L1009 292.5V295L1010 297L1010.5 299L1011 300L1011.5 302L1012 303L1012.5 304.5L1013 306L1014 308.5L1014.5 310.5L1015 312V313L1014 315V319L1013 321V329L1012.5 330.5V347L1013 350V354L1014 356.5V361.5L1015 364V368L1016 373L1016.5 375.5L1017.5 379L1018.5 382V384.5L1019 387.5L1020 390.5L1021 394.5L1022 398.5L1023 402.5L1024.5 406.5L1026 410L1027.5 414L1030 418.5L1031.5 421.5L1033 424.5L1034.5 427.5L1036.5 430.5L1038 432.5L1040 436L1041.5 438.5L1042.5 440.5L1043.5 441.5L1044 443L1045.5 444.5L1047 447L1048 449.5L1049 451.5L1050.5 453.5L1055 462L1056.5 463.5L1058 466L1059.5 468L1060.5 470L1061.5 472L1063 474L1064.5 476L1065 476.5V481V487L1065.5 490L1066 492V499L1067 502V511L1068 514V518L1069 521V524L1070 526V528L1070.5 529.5V536.5L1074.5 540.5H1075.5H1076.5L1077 539V536V532L1081.5 527.5H1083.5L1085.5 526L1087 525.5H1092L1097 523H1107L1108 524L1109.5 524.5L1110 522V516.5V514L1109 510V506L1108 502V495L1107 491V484L1106 480V472L1105 468V463L1104 459V451.5L1103 448V444L1102 441V429L1101 426V418.5L1100 414V405L1099 401V391L1098 387V377L1097 373V369V364L1096 360.5V355L1095 353V345L1094 342V333L1093 329.5V321L1092.5 319V316L1092 314V308L1091 305V290L1090 286V281L1089 277V271.5L1088 268V262.5L1087 260V256V253.5L1086 250.5V246L1085 242.5V237.5L1084 233.5V228L1083 225V221L1082 218V213L1081 211V210.886V204L1080 201.5V194.5L1079 192.378V185L1078 182V174L1077 171V164L1076 162V157L1075 154V150.5L1074 148V146L1073 143V141L1072 138.5V137L1071 135V133L1070 131V130L1069 127.777L1068.11 126L1067 124L1066.5 122V121V119L1066 117L1065 115L1063.5 112.5L1061 110L1060 109L1059 107L1058 105.5L1057 104L1055 102L1054 101.5L1053 101H1051V99.5L1050 98L1048 97L1047.5 96.5H1045L1043 96L1040 93H1037.5Z',
    },
    {
      zoneNames: ['Left Roof'],
      path: 'M238 552V550L238.5 547.5L239.5 546.5L241.5 547.5L244 549L245.5 549.5H250L253 550H256L258.5 550.5L261 551.5L263 552.5L265 553L269 553.5L270.5 554.5L271.5 555.5H274L275.5 556.5L276.5 557L278 558L278.5 559.5L281.5 562L285.5 565.5L287.5 566.5L288.5 567.5L289.5 568.5L290.5 569L291.5 570L292.5 571L294 572L295 573L296 574L296.5 575.5L298 577L299 578L300 579.5L301 580.5L302 582V584L302.5 584.5L303 585.5L303.5 587.5L305 589V590L306 591L307 592L308 594L309 597L310 599L312 605L314 611V612L315 615V618.5L316 621V623L317 626V629L318 632V634.5L319 637.5V640L319.5 643V648.5L320 651V658L320.5 661.5V669.5L320 672V681.5L319.5 684.05V689.5L319 692.5V695L318 698V702.5L317 705V708L316 711V714L315 716.5V719L314 721V722.5L313 725V728L312 731L311.5 733V736V739L311 741L310 744.5L309 748.5L307.5 753L304.5 760.5L301.5 763.5L302.5 766.5V790.5L301.5 795.5V802L300.5 808V816L298.5 826.5V831L296.5 839.5L295 843.5V848L292.5 855.5L291 858.5L290 863.5L288 865.5V871.5L287.5 875.5L288 879L289 881.5L290 885L291.5 888.5L294 895L295 898L297 902V904L298 906L299 908V909L300 911V912.5L301 914.5V916L302 918V919L303 921V923L304 925V930L304.5 931.5V936L304 937V940L303.5 941.5L303 942.5L302.5 944.5L302 946L301.5 947.5L301 949L300.5 950.5L300 951.5L299.5 953.5L299 955L298.5 956.5L298 957.5L297.5 959.5L297 960L296.5 961.5L296 962L295.5 963.5L295 964L294.5 966L294 967L293.5 969L293 970L292.5 972L292 973L291 975.5V976.5L290 978.5V979.5L289 982V983L288 985.5L287 988V989.5L286 991.5V993L285 995V997L284 1000V1001.5L283 1004L282 1007L281 1009.5V1011.5L280 1015V1016L279 1019L278 1021.5L277 1024.5L276 1027L273 1033L271 1037L269.5 1039.5L267.5 1042L266.5 1043.5L265.5 1045.5L264.5 1047.5L260.5 1051.5L260 1053.5L259.5 1055.5L257.5 1056.5V1054V1051.5V1049L258 1047V1045L257 1043V1041.5V1040L258.5 1039.5V1038.5V1036.5L257.5 1035V1033.5H258.5V1032.5V1031.5L257 1030L256.5 1028.5L255.5 1027.5L252.5 1024.5L250.5 1022.5H248L246 1021.5L245 1021L244.5 1020L243.5 1018.5H242.5H241.5L241 1019H237L233 1018H228L227 1017H225L223 1018H216.5L215 1018.5H209.5L208.5 1015.5V1013.5L207.5 1011.5V1008L206.5 1004.5V997.5L205.5 994.5V975.824L206 973V960L207 957V939L208 935.708V921L209 918V910L210 906V896L211 893V884L212 881V867L213 864V852.963L214 850V840L215 837V828L216 825V816L217 813V802L218 799.126V788L219 785V778L220 774V766L221 763V753L222 750V738L223 733.89V723.5L224 719.5V711L225 708V699.5L226 696.313V683L227 680V670L228 667V656L229 653V647L230 644V636L231 633V625L232 622V614L233 611.107V602L234 599V591L235 588V580L236 577.194V570L237 567V560L238 558V552Z',
    },
    {
      zoneNames: ['Right Roof'],
      path: 'M1106 549L1108 548H1109H1111L1112 551V557L1112.5 559V561L1113 562.5V570.163L1113.5 572V575L1114 577V580L1114.5 583V585L1115 588V597L1115.5 599V601L1116 603V606.5V610L1116.5 612V614.5L1117 617V622L1117.5 624V626L1118 628V633.5L1118.5 635.5V638L1119 640V646L1119.5 648V651L1120 653V656L1120.5 658V660L1121 662V667L1121.5 669V671L1122 673V684L1122.5 686V688L1123 690V698L1123.5 700V702L1124 704V713L1124.5 715V717L1125 719V727L1125.5 729V731L1126 733V743L1126.5 745V747L1127 749V758L1127.5 760V762L1128 764V772.116L1128.5 774V776L1129 778V786L1129.5 788V790L1130 792V803L1130.5 805V807L1131 809V820L1131.5 822V824L1132 826V835L1132.5 837V839L1133 841V854L1133.5 856V858L1134 860V873L1134.5 875V878L1135 880V893L1135.5 895V897L1136 899V911L1136.5 913V915L1137 917V924L1137.5 926V928L1138 930V940L1138.5 942V944L1139 946V967L1139.5 970V988L1139 991V996L1138 999L1138.06 1007.07L1138 1007L1137 1010V1011L1136 1014V1016L1135 1018L1132.25 1018.5L1130 1019H1128L1126 1018.5H1121L1119 1017.5H1116.5L1114 1018.5H1112L1109 1019L1107 1019.5H1105L1104 1019H1102.5L1101.5 1020.5L1100 1022L1098.5 1022.5H1097L1091.5 1027.5L1090.5 1029V1031.5L1090 1034.5V1036.5V1041.5L1089 1043.5L1088.5 1046V1051.5L1086 1050L1084 1048L1083 1047L1082 1045L1081 1043L1080 1041L1079 1040L1078 1038L1076.5 1036L1075.5 1033.5L1074.5 1032.5L1074 1031L1073.5 1029L1072.5 1027.5L1070.5 1023.5L1070 1022L1069 1020L1068 1016L1067 1014L1066 1010L1064 1006V1004L1063 1002V1000L1062 998V997L1060 993V992L1059 990V989L1058.5 987L1058 985.5V983.5L1057 981.5V980.5L1056 978.5L1055 976V974.5L1054 972.5V970.5L1053 968.5V966.5L1052 964.5V963.5L1050.5 961.5L1050 960.5V959.5L1049 958V957L1048 955V954L1047 952V950.5L1046 949V947.5L1045 946V944.5L1044 943V940.5L1043.5 939L1043 937V935L1042.5 933V930.5L1043 928.5V925L1044 922V920L1045 917V916L1046 913V912L1053 891L1054 889L1055 886L1056.5 882.5L1057.5 880L1058.5 878.5V875.5L1057.5 873.5V870L1058.5 867.5V865.5L1056.5 862L1056 858.5L1055 855.5L1053 850L1052 846.5L1051 841.5V837V831.5L1049 828L1048 820.5V813V808.5V805V803L1047 799.5L1045.5 795.5V790V786V780.5V774V769L1046 764.5L1045 762.5L1043 759L1042 754L1040.5 748L1040 743L1039 739L1038.5 735.5V733L1037 729.5L1036.5 727.5V725L1036 722.5L1035.5 721V719L1035 717L1034.5 715.5V714L1033.5 710.5V708.5L1033 706V704L1032.5 702.5V700.5L1032 698.5V695L1031.5 693.5V691.5L1031 689.5V686L1030.5 684V678L1031 675.5V673.5L1030.5 671.5V665.5L1031 663V660L1031.5 657.5V655.5L1032 653V651L1032.5 649V647L1033 645V644L1033.5 642V640L1034 638V635L1034.5 633L1035 631L1035.5 628L1036 627L1039 619V616L1040 613V612L1042.5 604.5L1043.5 602.5L1044.5 600.5L1045 599L1046 597V596L1047 594V593L1048.89 589.057L1049 589L1052 586V585L1057 580V579L1059 577V576L1060 574L1077 557L1079 556.5L1081 555.5L1083 554.5L1084.5 554L1086.5 553L1088.5 552.5C1088.5 552.5 1089.4 552.161 1090 552L1093 551L1096 550.5H1099.5H1102L1105 550L1106 549Z',
    },
    {
      zoneNames: ['Left Rear Door'],
      path: 'M320 732L318 733H317L315 734L314 734.5L312.5 735.5L311.5 737.5V739L309 748.5L307.5 753L304.5 760.5L301.5 763.5L302.5 766.5V790.5L301.5 795.5V802L300.5 808V816L298.5 826.5V831L296.5 839.5L295 843.5V848L292.5 855.5L291 858.5L290 863.5L288 865.5V871.5L287.5 875.5L288 879L289 881.5L290 885L291.5 888.5L294 895L295 898L296.5 900.5L298 901.5L300 903L301 903.5L302.5 904.5L305 906H308L311 907L312 908H321V907L322 906L324 905L326.5 904L329 903L330 902L333 901L335 899L336 897L345 888L348 883L351 878L355 869L356 867V866L357 864V863L358 861V859L359 857V855L360 853V851L360.5 848V846L361 843V835L362 832V827L362.5 824V821L363 818V797L362.5 794V790L362 789V786L361.5 784L361 783V782L360.5 779.5L360 778L359.5 775L359 774V772L358 770L357 768L356.5 766.5L356 764.5L355 762.5L354 760.5L353.926 760.351L353 758.5L352 757L351.5 755.5L350 754L349 752L346.5 749.5L345 747.5L343.5 745.5L342.5 744.5L341.5 743L341 742L339 740L337.5 739L336.5 738L334 737L332 736H327L326 735.5L325 734.5L324 733.5L322 732H320Z',
    },
    {
      zoneNames: ['Right Rear Door'],
      path: 'M1013 734L1015 733.5H1019L1020 733L1023.5 730.5H1026.5L1027 731L1029 732L1031 732.5H1035L1037 733L1038.5 735.5L1039 739L1040 743L1040.5 748L1042 754L1043 759L1045 762.5L1046 764.5L1045.5 769V795.5L1048 803V820.5L1049 828L1051 831.5V841.5L1052 846.5L1053 850L1056 858.5L1056.5 862L1058.5 865.5V867.5L1057.5 870V873.5L1058.5 875.5V878.5L1057.5 880L1055 886L1054 889L1053 891L1051 897L1049 899L1047 900L1044.5 901.5L1041.5 902.5L1039.5 903.5L1036 904L1033.5 905.5H1029.5H1026L1024 905L1022.5 904.5L1022 904L1021.5 901.5L1018.5 901L1016 900.5L1014 899.5L1013 899L1005 891L1004 889L1003 888L1002 886L1001 885L1000 884L999 882L998 880L996.792 878L995.833 877L990 865L989 862L988 860V858L987 855L986.5 853V851L986 850V849L985.5 847.5V846.5L985 845V840L984.5 837V836L984 834V824L983.5 821V819L983 817V806L982.5 803V799L983 796V788L984 786V781L985 779.5V777L986 776V774L987 772V770L988 768V767L989 765V764L991 760V759L993 755L993.5 754L995 752L997 748L998 747L1000 744L1000.5 742.5L1003 740L1005 739L1006.5 738L1010 735L1013 734Z',
    },
    {
      zoneNames: ['Rear Left'],
      path: 'M409 893H418H446L450 893.5H454L457 894H461.5L464 894.5H466.5L469 895H470L473 896H475L477 897H478L480 898H481L483 899L485 899.5L487 901L488 902L490 903L492 904L494 906V907L495 909L496 910L500 914V915L502 917V918L506 923V924L507 926V927L508 929V931L509 934V939L509.5 942V960L509 962V967L508 970V973L507 975V977L506 979.5V981L505 983V984L504 986V987L503 989V990L502 992.5L501 994.5L500 997L499 999L498 1000L497 1002L493.5 1005.5L493 1007L490 1011V1012L489 1014L487 1015H486L484 1016H483L480.5 1017H479L476 1018H475L472 1019H469L466 1019.5H457L452 1020H406.5L401.803 1019.5H379L376.5 1019H374L371.5 1018.5H369.5L367.5 1018H366.5L364.5 1017.5L363 1017L361.5 1016.5L360 1016L359 1015.5H357.5L356.5 1015L355.5 1014.5H354.5L352 1012V1011L351.5 1008.5L351 1008L346 1003L344.5 1000L344 999L342 995V994L341 992V991L339 985.5V983.5L338 981V979L337 977V975L336 973V968L335.5 965V948L336 945V940L337 938V935L338 933V930L339 928V927L340 925.5L340.5 924.5L342 922.5L342.5 921.5L344.5 919L345 918L346 917L346.5 916L347 915L352 910L359.5 903L361 902L363 900.5L365 899.5L367 899L369 898.5L370 898L372 897.5L373 897L375.5 896.5H377L378 896L380 895.5H382L383 895L386 894.5H389L390 894H399L403 893.5H406L409 893Z',
    },
    {
      zoneNames: ['Rear'],
      path: 'M583 925L587 919L589 916.5L590 915L597 908V907L600 904L604 902L604.5 901.5L607 900.5L612 898H613L615 897H617L620 896H623L626 895H631L635 894H650L654 893.5H661L664 893H674L677 893.5H691L694 894H704L707 895H709L711 895.5H712L713 896H715L717 897H718L720 898H721L723 899H724L728 901H729L733 904.5V905L734 907L735 908L741.5 915L742 916L743 917L745.985 922.969L748 927L749 928L750 930V935L751 938V940L752 943V947L752.5 950V958L752 961V969L751 972V975L750 978V980.5L749 982.5V984.5L748 986.5V988L747 991L746 993L744 997V998L742 1001.5L741.5 1002.5L735 1009V1010L733 1014L731 1016H729L727 1017H725L723 1018H719L717 1019H715L711 1020H699L691 1020.5H625L616 1020L614 1019H611L609 1018H606L604 1017H603L601 1016H600L599 1015.5L597 1013L596 1011V1009L594 1007H593L591 1005L585 993V992L584 990V989L583 987V986L582 984V983L581 980V978L580 976V972L579 969V942.815L580 940V936L581 934V931L582 929V927L583 925Z',
    },
    {
      zoneNames: ['Rear Right'],
      path: 'M829 928L831 924V923L832 922V921L833 920L834 918V917L836 915V914L839 911L840.5 910.5L843 908L844 906L848 902H849L855 899H856L858 898H859L861 897H862L865 896H867L870 895H873L876 894H896L899 893.5H904L907 893H931L934 893.5H940L943 894H954L956 895H958L960 895.5H961L962 896H964L966 897H968L970 898H971L979 902L980.5 902.5L982.5 904.5L983.5 906L984.5 908L986 909L994 917L994.5 918L995 919L997 921L997.5 922L999 924V925L1000 927V928L1001 930V933L1002 935V937L1003 939V943L1003.5 945V946L1004 946.902V968L1003.5 970V972L1003 974V976L1002.5 977.5V979L1002 980V982L1001 984V986L1000 988V989L999 991V992L997 996L996 999L994 1003L988 1009V1011L987 1013V1014L985 1016H984L981 1017H980L977 1018H973L970 1019H968L965 1020H952L948 1020.5H876L872 1020L869 1019.5H866L863 1019H860L857 1018L851 1016H849L847 1014L846 1012V1011L845 1008L844 1007L842 1006.5L841 1006L839.5 1004L836 997L835 994L834 992L833 990L829 978V976L828 973V970L827 967V960L826.5 956V947L827 944V941L827.5 939V937L828 935V930L829 928Z',
    }
  ];

  public additionalAirbags: IImageZone[] = [
    {
      zoneNames: ['Passenger Dash Lower Panel', 'Left Lower Front Seat'],
      path: 'M217 348L218.5 346.5L221 346L223 345.5H226L227.5 346L231 346.5H248L253 347H261L265 347.5L267 348H278L282 348.5L285 349H296L299.5 350H310L312.5 351H327L330.5 352H341L345.5 352.5L348 353H358L360 354H369L371 355H377L379 356H385L387.5 357H401L403.5 358H405L406.5 359L408.5 360H428.5L430.5 361H436L438 362H446.5L449.5 363H459.5L462 364H471L474 365H484L486 366H493L495 367H501L503 368H514.5L516.5 369H519.5L520.5 369.5L523 371.5L524 372H527L528 371.5L531 372L535 376L537 377L538 378L540 380L540.5 384.5L542 386.5L544 389L545 392V395.5L544 398V405L543 408.5V412.5L542 417V418.5L541 420V421L540.5 422.5L540 424L539.5 425.5L539 426.5L538.5 427.5L538 428.5L537.5 430L537 431.5L536.5 432.5L536 433.5L535.5 434.5L535 435.5L534.5 436.5L534 437.5L533.5 438.5L533 440L532.5 440.5L532 442.5L531.5 443.5L531 444.5L530.5 445.5L530 447.5L529.5 448.5L528.5 450L528 451.5L527.5 452.5L527 453.5L526.5 454.5L526 455.5L525.5 456.5L525 457.5L524.5 458.5L524 459.5L523.5 460.5L523 461.5L522.5 462.5L522 463.5L521.5 464.5L521 465.5L520 466.5L519.5 467.5L519 469L518 470V471L517 472.5L516.5 473.5L515 475.5L514.5 476.5L514 477.5L513.5 478.5L513 479.5L512 481V481.5L511.5 482.5L508.5 485.5L507.5 487.5L506.5 488.5L506 490L504 492.5L503 493.5L502 495V496L500 498V499L499 500V501L498.5 501.5L497 503V504L485 516L483.5 516.5L482 518L480.5 518.5L478.5 520.5L477 521.5L475.5 522.5L474 523.5L472 525L470 526L469 526.5L467 527L466 527.5L464.5 528L464 529L462 530H455L453.5 531H443L441 530H421L419 529H409L407 528H389L387 527H371L369 526H359L356.5 525H346L344 524H331H329L327 523H321L319 522H304.5L303 521H300.5L299 520H297L296 521H294L293 521.5H290L289 521L287 519H278.5L276.5 518H274.5L273 517H271.5L270 516H269.5L268 515H267.5L266 514H264L263 513L261.5 512.5L260 512L259.5 510.5L259 510V508L258 507V506L256 505H255L253 504H252L251 503L250 502V501L249 500L248 499V498L247 496V492.5L246 492L245 491L243 489L242 488V487L241 486L240 485V484L239 483L238 481.5V480.5L237 479V478.5L236 477L235 476V475L234 474V473L233 472V471L232 470V469L231 468V467L230 466V465L229 463.5V462.5L228 461V460L227 458.5V457.5L226 456V455L225 453.5V452.5L224 450.5V449.5L223 448V446.5L222 444.5V443.5L221 441.5V438.5L220 437.5V435.5L219 434V431.5L218 430V427.5L217 426V423.5L216 422V418.5L215 417V413L214 411V406L213 403.5V373.5L214 371.5V369.5L215 368V366L216 364L217 363V362L216 359.5L215.5 357.5V353L216 351.5V350L217 348Z',
    },
    {
      zoneNames: ['Driver Instrument Lower Panel', 'Right Lower Front Seat'],
      path: 'M981 408L983 410L984.5 412L987 415L988.5 417L989.5 418.5L991.5 420.5L996.5 426L998 428L1004 434L1005.5 435L1013.5 443L1014.5 443.5L1016.5 445.5L1020 448L1022.5 450.5L1023.5 451L1025 452L1028 454.5L1030.5 456.5L1032.5 457.5L1036.5 460.5L1038.5 461.5L1040.5 463L1041.5 463.5L1046 466L1047.5 467L1061.5 474L1063 475L1064.5 475.5L1067.5 477H1068.5L1070 478L1072 479H1073L1074.5 480H1076L1077.5 481H1079L1080.5 482H1082L1083 483H1085L1086.5 484H1088.5L1090 485H1091.5L1093 486H1095.5L1097 487H1099L1101 488H1103L1104.5 489H1107L1108.5 490H1112.5L1114.5 491H1118L1120 492H1126.5L1129 493H1137L1139 494H1168L1170.5 493H1178.5L1181 492H1185.5L1188 491H1191.5L1193.5 490H1196.5L1199 489H1201L1203.5 488H1206L1208 487H1210L1212 486H1213L1215 485H1217L1219 484H1220L1222.5 483H1223.5L1225.5 482H1226.5L1228.5 481H1230L1232 480L1235.5 478.5L1238.5 477.5L1240.5 476.5L1243 475.5L1261 466.5L1264 464.5L1270 461.5L1273 459.5L1275 458L1278 456L1280 455L1286 450L1288.5 448.5L1296 442L1299 440L1313 426H1315V428L1316 430V432L1317 434V437L1318 439V443L1319 445V448L1320 450V454L1321 456V464L1321.5 466.5V477.5L1321 480V490.5L1320 492.5V496.5L1319 498.5V502.5L1318 504.5V508L1317 509.5V511.5L1316 513V515.5L1315 517V519.5L1314 521V523L1313 524.5V526.5L1312 527V529L1311 530V531.5L1310 533V534.5L1309 536V537.5L1308 539V540L1307 541V542L1306 543.5V545L1305 546V547L1304 548.5V549.5L1303 551.5L1302 552.5L1301.5 553.5L1301 555L1298 559.5L1297.5 560.5L1296.5 561.5L1296 563L1291.5 567.5L1289 572.5L1287 574.5L1286 575L1285 576H1283L1279 578L1278 580H1276L1275 581L1271 583H1269L1268 584H1263L1261 585H1257L1255.5 586H1251L1249.5 586.5H1237L1236 586H1235L1232.5 585H1229.5L1228 584H1226L1224 583H1222L1220.5 582H1220L1218.5 581H1218L1216 580H1215.5L1214.5 579.5L1213 579L1208 574L1207.5 573L1206.5 572L1206 571L1203 568L1202.5 566.5L1201.5 565L1201 564L1200 563L1199 561L1197.5 560H1195.5L1193.5 561H1191.5L1191 561.5H1189L1188 561H1186.5L1185 560.5H1183L1182 561H1169.5L1168 562H1163.5L1162 561H1160.5L1157.5 562H1152.5L1151 561H1147L1145 562H1130L1127.5 561.5L1126.5 561H1125.5L1124 561.5H1117L1115 562H1111.5L1110 561.5L1108.5 562H1079.5L1078 561.5L1077 562H1059.5L1057.5 562.5L1055.5 562L1053.5 561H1052L1051 562L1050 562.5H1044L1043 562H1041.5L1039.5 564L1038 565H1037.5L1036 566L1035 566.5L1033 568L1032 568.5L1031 570L1030 571L1029 573L1028 574L1027 575.5L1024.5 577.5L1024 578.5L1023 579.5L1022 581.5L1020.5 583L1018.5 584L1017 585H1014L1012.5 586L1011.5 587L1010 588H1009.5L1007.5 589H1006.5L1005 590H1003.5L1001.5 591H996.5L994 591.5H983L981 591H977L975 590H971.5L970 589H965.5L961.5 587L960 586L957 583H952L950.5 582L949.5 581L948.5 579.5L948 578L945 576L941 572L939 569L937.5 567.5L937 566L935 564L934 562L932.5 560L931.5 558L930 556L928.5 553L927.5 550.5L926.5 549L925.5 546.5L921.5 538.5L920.5 535.5L919.5 533.5L918.5 530.5L917.5 528.5L916.5 525L915.5 522L914.5 518.5L912.5 510.5L912 506L911 502.5L910 498.5V496L909.5 494L909 490.5L908 487.5V481.5L907 479V471.5L908.5 468.5V466.5L907.5 465L905.5 461.5V455L907 452.5L908 450.5V448.5L907.5 446V444L908.5 442L910 441L913.5 438L916 435V427L919 424L920 423.5H921.5L925 423L927 421L929 417L931 415L933 414L934 412.5H935.5L937.5 413L940 412L940.5 411L942 409.5L944 408H946.5L949 407H953L954.417 406.5H980L981 408ZM1036 409H1039L1042 410L1044.5 410.5L1089 411L1090.5 412L1092 413.5V414.5L1092.5 416.5L1093.5 417.5L1094 419L1099 429L1100 432L1101 433L1101.5 434.5L1099.5 435.5L1098 436.5L1095 439L1091 441L1090 442.5H1088L1086.5 443H1084L1083 443.5L1080 442H1076.5L1074.5 441L1073 440H1071.5L1070.5 439.5L1068.5 438L1067.5 437H1066L1063.5 436L1063 435L1061 433L1057.5 432.5L1055 430L1053 429.5L1052 429L1049.5 426H1048L1047 425L1045.5 424L1044 422L1040 420L1039 419L1036.5 418L1036 416L1034.5 414.5L1032.5 414L1031.5 413L1028.5 409L1029 408H1034L1036 409ZM1291.5 397L1291 398L1289.5 400.5L1283 407L1279 410L1275 414L1272 416.5L1269.5 418.5L1266 422L1264 423.5L1258 427.5L1257 428.5L1254 430.5L1252 431.5L1249 433.5L1245 435.5L1243.5 436.5L1241.5 437.5L1239.5 438L1237.5 439L1236 440H1233.5L1231.5 441H1222.5L1221 440H1218.5L1217 439H1216L1211 434H1209.5L1209 433V431.5L1210 430V428.5L1211 427V425.5L1212 424V423L1213 422V421L1214 419V417L1216 413V411L1217 409.5V409L1218.5 407L1219.5 405L1220.5 403.5V402.5L1222 401L1223.5 400.5L1225 399.5L1227 398.5L1231.5 397L1236 396.5H1275.5L1281 395.5H1288L1291.5 397ZM1175 412L1174 414V419L1173 421V425L1172 427V427.5L1171.5 428.5L1171 430L1169.5 431H1168L1166.5 432H1138.5L1136.5 431L1135.5 430L1134 429L1133 427V425L1132 423.5V421.5L1131 418.5L1130 416L1129 414V410H1148L1150 409H1161L1163 408H1168.5L1170.5 407.5H1175V412Z',
    }
  ];

  public hasAdditionalAirbags = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formDataService: FormDataService,
    private pagerService: PagerService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private configService: ConfigService,
    public matDialog: MatDialog,
    private el: ElementRef,
    private config: NgbDatepickerConfig
    //public dialogRef: MatDialogRef<ModalComponent>
  ) {
    this.contentDetail = this.configService.config.Data.contentDetail;
    this.errorMsg = "";
    this.isEasyClaimTlAcceptType = this.formDataService.getIsEasyClaimTlAcceptType();
    this.enableSubmitBtn = true;

    if (this.isEasyClaimTlAcceptType == true) {
      this.enableSubmitBtn = false;

      var showTLAcceptCb = this.contentDetail.ShowTLAcceptCb.toLowerCase();
      if (showTLAcceptCb == "yes") {
        this.showcbTermsConditions = true;
      } else {
        this.showcbTermsConditions = false;
        this.enableSubmitBtn = true;
      }
    }

    this.damageConditions = this.configService.config.Data.DamageConditions;
    this.directionOfImpacts = this.configService.config.Data.DirectionOfImapcts;
    this.damageDetails = this.configService.config.Data.DamageDetails;

    const current = new Date();
    config.maxDate = {
      year: current.getFullYear(), month:
        current.getMonth() + 1, day: current.getDate()
    };

    this.investigationType = this.configService.config.Data.Investigation_type;
    this.stpDelay = this.configService.config.Data.STPDelay;
    this.isAnswersValid = true;
  }

  ngOnInit() {
    var photoEl = this.el.nativeElement.parentElement.parentElement.childNodes[0].childNodes[0];
    if (photoEl != null) {
      photoEl.classList.remove("disableCls");
    }

    this.questionsForm = this.formBuilder.group({});
    this.questions = this.formDataService.getPhase1Questions();

    var easyClaimType = this.formDataService.getEasyClaimType();
    if (easyClaimType == "EasyClaimTL") {
      var filterString = "";
      if (this.isEasyClaimTlAcceptType == true) {
        filterString = "accept";
      } else {
        filterString = "decline";
      }

      this.questions = this.questions.filter(x => x.AcceptDeclineType == filterString);
    }

    let vrn = localStorage.getItem("vrn");
    let odometer = localStorage.getItem("odometer");
    let accidentDate = localStorage.getItem("accidentDate");

    this.questions.forEach((q, i) => {
      if (vrn != "" && q.question_type === "vrn") q.Answer = vrn
      if (odometer != "" && q.question_type === "odometer") q.Answer = odometer;
      if (accidentDate != "" && q.question_type === "incident_date") {
        let dateOnly = accidentDate.split(" ")[0];
        let dateOnlyArr = dateOnly.split("/");
        q.Answer = `${ dateOnlyArr[1] }-${ dateOnlyArr[0] }-${ dateOnlyArr[2] }`
      }
      const fc: FormControl = new FormControl(q.Answer);
      this.questionsForm.addControl(q.qn_number, fc);
      if (q.answer_type === 'free_text') {
            fc.valueChanges
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((value: string) => {
                this.invalidCharErrors[q.qn_number] = value ? !this.noHtmlPattern.test(value) : false;
              });
          }
    });
    this.initSubscription();
    this.updateSelectedAirbags();
    this.setPage(1);
  }
private readonly noHtmlPattern = /^[^<>]*$/;

public invalidCharErrors: { [qnNumber: string]: boolean } = {};

onFreeTextInput(question: any, event: Event): void {
  const value = (event.target as HTMLInputElement).value;
  console.log('Input value:', value);
  this.invalidCharErrors[question.qn_number] = value ? !this.noHtmlPattern.test(value) : false;
}

private sanitizeInput(value: string): string {
  if (!value) return value;
  return value
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '') // remove script blocks entirely
    .replace(/<\/?[^>]+(>|$)/g, '')                     // strip remaining tags
    .trim();
}

  private initSubscription() {
    this.airbagsForm.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => this.updateSelectedAirbags());
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  bindAnswers() {
    Object.keys(this.questionsForm.controls).forEach(key => {
      this.questions.forEach((q, i) => {
        if (q.qn_number === key) {
          if (q.answer_type === 'date') {
            //q.Answer = EcUtils.format(this.questionsForm.controls[key].value);
            var dateVal = this.questionsForm.controls[key].value.split('-');
            q.Answer = dateVal[0].padStart(2, '0') + '-' + dateVal[1].padStart(2, '0') + '-' + dateVal[2];
          } else if (q.answer_type === 'dropdown') {
            if (q.question_type == 'direction_of_impact') {
              if (this.directionOfImpactValue != '') {
                q.Answer = this.directionOfImpactValue;
              }
            } else if (q.question_type == 'damage_details') {
              q.Answer = this.damageParts.join();
            } else {
              q.Answer = this.questionsForm.controls[key].value === "select" ? "" : this.questionsForm.controls[key].value;
            }
          } else if (q.answer_type === 'free_number') {
            q.Answer =  this.questionsForm.controls[key].value;
            if (this.isEasyClaimTlAcceptType) {
              if (q.question_type == "account_number" && (q.Answer == null || q.Answer == "" || String(q.Answer).length != 8)) {
                if (this.errorMsg != "") {
                  this.errorMsg += ", Account Number must be 8 numeric characters"
                } else {
                  this.errorMsg = "Account Number must be 8 numeric characters";
                }
                this.isAnswersValid = false;
              } else if (q.question_type == "sort_code" && (q.Answer == null || q.Answer == "" || String(q.Answer).length != 6)) {
                if (this.errorMsg != "") {
                  this.errorMsg += ", Sort Code must be 6 numeric characters"
                } else {
                  this.errorMsg = "Sort Code must be 6 numeric characters";
                }
                this.isAnswersValid = false;
              }
            }

          } else if (q.answer_type === 'multiple_selection' && q.question_type === 'multiple_airbag') {
            q.Answer = this.getAirbagsForServer().join();
          } else {
            const trimmed = this.questionsForm.controls[key].value.trim();
            if (!this.noHtmlPattern.test(trimmed)) {
              this.errorMsg = this.errorMsg
                ? this.errorMsg + `, ${q.question_text || 'This field'} contains invalid characters`
                : `${q.question_text || 'This field'} contains invalid characters`;
              this.isAnswersValid = false;
            }
             q.Answer = this.sanitizeInput(trimmed);
          }
        }
      });
    });

    if (this.isAnswersValid == false) {
      return false;
    }
    return this.questions.every(q => {
      return ((q.is_required == 'no') || (q.is_required == 'yes' && q.Answer));
    });
  }


  photos() {
    this.bindAnswers();
    this.router.navigate(['../photos'], { relativeTo: this.route });
  }

  submit() {
    let isValid = this.bindAnswers();
    console.log('in submit ' + isValid);
    if (isValid) {

      //11
      // this.formDataService.setSubmitDateTime(new Date().toUTCString());
      // const http$ = this.formDataService.sendData();

      // this.openModal();
      // this.errorMsg = "";

      // http$.subscribe(res => {
      //   this.closeModal();
      //   this.formDataService.setTimeStampType("p1informationreceived");
      //   this.formDataService.setTimeStampDateTime(new Date().toUTCString());

      //   const http$ = this.formDataService.submitTimeStamp();
      //   http$.subscribe(res => {

      //   }, err => {
      //     console.log(err);

      //   });


      //   if(res.IsError == true)
      //   {
      //     this.errorMsg = res.Messages[0].Message;
      //   }
      //   else
      //   {
      //     this.matDialog.afterAllClosed.subscribe(result => {

      //       if(this.investigationType.toLowerCase() == "automatic" && this.stpDelay != null)
      //       {
      //         const http$ = this.formDataService.sendAutomaticEmail();
      //         http$.subscribe(res => {

      //         }, err => {
      //           console.log(err);

      //         });
      //       }
      //     });

      //     this.formDataService.setEngineeringOutcome(res.EngineeringOutcome);


      //       this.router.navigate(['../response'], { relativeTo: this.route});
      //   }


      // }, err => {
      //   this.closeModal();
      //   console.log(err);
      //   this.errorMsg = "Your information was not able to be submitted. Please check your internet connection and try again";
      // });

      //11

      //11 new Photo page changes
      this.formDataService.setTimeStampType("p1questionpagecontinuedate");
      this.formDataService.setTimeStampDateTime(new Date().toUTCString());

      const http$ = this.formDataService.submitTimeStamp();
      http$.subscribe(res => {

      }, err => {
        console.log(err);

      });

      this.router.navigate(['../photos'], { relativeTo: this.route });
      //11 new Photo page changes

    } else {
      this.closeModal();
      this.toastr.error('Please fill in required information.', 'Validation Error', {
        positionClass: 'toast-center-center',
        timeOut: 2000
      });

    }
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.questions.length, page, 10);

    // get current page of items
    this.pagedItems = this.questions.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }


  openModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "400px";
    dialogConfig.width = "500px";

    const modalDialog = this.matDialog.open(ModalComponent, dialogConfig);
  }

  closeModal() {
    this.matDialog.closeAll();
  }

  enableSubmit(e) {
    if (e.target.checked) {
      this.enableSubmitBtn = true;
    } else {
      this.enableSubmitBtn = false;
    }
  }

  submitEasyClaimTlAccept() {
    this.errorMsg = "";
    this.isAnswersValid = true;
    let isValid = this.bindAnswers();
    if (isValid) {
      //11
      this.formDataService.setSubmitDateTime(new Date().toUTCString());
      const http$ = this.formDataService.submitEasyClaimTlAccept();

      this.openModal();
      this.errorMsg = "";

      http$.subscribe(res => {
        this.closeModal();
        this.formDataService.setTimeStampType("tlofferaccepted");
        this.formDataService.setTimeStampDateTime(new Date().toUTCString());

        const http$ = this.formDataService.submitTimeStamp();
        http$.subscribe(res => {

        }, err => {
          console.log(err);

        });

        if (res.IsError == true) {
          this.errorMsg = res.Messages[0].Message;
        } else {
          this.matDialog.afterAllClosed.subscribe(result => {

            if (this.investigationType.toLowerCase() == "automatic" && this.stpDelay != null) {
              const http$ = this.formDataService.sendAutomaticEmail();
              http$.subscribe(res => {

              }, err => {
                console.log(err);

              });
            }
          });


          this.router.navigate(['../response'], { relativeTo: this.route });
        }


      }, err => {
        this.closeModal();
        console.log(err);
        this.errorMsg = "Your information was not able to be submitted. Please check your internet connection and try again";
      });
      //11


    } else {
      this.closeModal();
      this.toastr.error('Please fill in required information.', 'Validation Error', {
        positionClass: 'toast-center-center',
        timeOut: 2000
      });

    }

  }

  setImpactDirection(directionOfImpact, directionOfImpactVal) {
    var divs = document.querySelectorAll(".vehicle-part");
    for (var i = 0; i < divs.length; i++) {
      divs[i].classList.remove('bg-green');
      divs[i].classList.add('bg-grey');
    }

    var currentDiv = document.getElementById(directionOfImpact) as HTMLElement;
    currentDiv.className += " bg-green";

    this.directionOfImpactValue = directionOfImpactVal;
  }

  public setHasAdditionalAirbags(value: boolean) {
    this.hasAdditionalAirbags = value;
    if (!value) {
      this.airbagsForm.get('additional').setValue([]);
    }
    this.updateSelectedAirbags();
  }

  public removeAirbag(names: string[]) {
    ['main', 'additional'].forEach(key => {
      const ctrl = this.airbagsForm.get(key);
      const values = (ctrl.value || []) as string[];
      const filtered = values.filter(n => names.indexOf(n) === -1);
      if (filtered.length !== values.length) {
        ctrl.setValue(filtered);
      }
    });
  }

  private updateSelectedAirbags() {
    const main = (this.airbagsForm.get('main').value || []);
    const additional = this.hasAdditionalAirbags
      ? (this.airbagsForm.get('additional').value || [])
      : [];
    this.selectedAirbags = [...main, ...additional];
    this.selectedAirbagChips = [
      ...this.buildAirbagChips(main, this.airbags),
      ...this.buildAirbagChips(additional, this.additionalAirbags)
    ];
  }

  private getAirbagsForServer(): string[] {
    const triggersRoof = this.roofTriggerZones.some(n => this.selectedAirbags.indexOf(n) > -1);
    const zones = triggersRoof ? [...this.selectedAirbags, 'Roof'] : [...this.selectedAirbags];
    return zones.map(name => this.airbagEnumMap[name] || name);
  }

  private buildAirbagChips(selected: string[], zones: IImageZone[]): ISelectedChip[] {
    return zones
      .filter(zone => zone.zoneNames.every(n => selected.indexOf(n) > -1))
      .map(zone => ({ label: zone.zoneNames.join(' / '), names: zone.zoneNames }));
  }

  setDamageDetails(partId, partName) {
    const element = document.querySelector(`.damageDetailDivCls #${partId}`) as HTMLElement;
    if (!element) return;

    if (element.classList.contains("bg-green")) {
      element.classList.remove("bg-green");
      element.classList.add("bg-grey");

      const damagePartIndex = this.damageParts.indexOf(partName, 0);
      if (damagePartIndex > -1) {
        this.damageParts = this.damageParts.splice(damagePartIndex, 1);
      }
    }
    else {
      element.classList.remove("bg-grey");
      element.classList.add("bg-green");

      this.damageParts.push(partName);
    }

  }

  openQuestionPopup(question: any) {
    this.selectedHeader = question.QuestionInfoHeader || '';
    this.selectedDetail = question.QuestionInfoDetail || '';
    this.displayStyleQuestion = 'block';
  }

  closeQuestionPopup() {
    this.displayStyleQuestion = 'none';
  }

}
